// extracted by mini-css-extract-plugin
export default {"sidebar":"theme_sidebar__UqG6a","logo":"theme_logo__Dsl7V","closeButton":"theme_closeButton__mSddx"};